import api from "./config";

// Obtener todas las citas
export const getCitas = async () => {
  try {
    const response = await api.get("/citas");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo citas:", error);
    return [];
  }
};

// Agregar una nueva cita
export const addCita = async (cita) => {
  try {
    const response = await api.post("/citas/", cita);
    return response.data;
  } catch (error) {
    console.error("Error agregando cita:", error);
    return null;
  }
};

// Editar una cita existente
export const updateCita = async (id, citaActualizada) => {
  try {
    const response = await api.patch(`/citas/${id}/`, citaActualizada);
    return response.data;
  } catch (error) {
    console.error("Error actualizando cita:", error);
    return null;
  }
};

// Eliminar una cita
export const deleteCita = async (id) => {
  try {
    await api.delete(`/citas/${id}/`);
    return true;
  } catch (error) {
    console.error("Error eliminando cita:", error);
    return false;
  }
};

// Obtener recordatorios pendientes de envío semi-automático
export const getRecordatoriosPendientes = async () => {
  try {
    const response = await api.get("/citas/recordatorios_pendientes/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo recordatorios pendientes:", error);
    return [];
  }
};

// Marcar recordatorio como enviado
export const marcarRecordatorioEnviado = async (recordatorioId) => {
  try {
    const response = await api.post(
      `/citas/recordatorios/${recordatorioId}/marcar-enviado/`
    );
    return response.data;
  } catch (error) {
    console.error("Error marcando recordatorio como enviado:", error);
    return null;
  }
};

// Desmarcar recordatorio como enviado y regresarlo a pendiente
export const desmarcarRecordatorioEnviado = async (recordatorioId) => {
  try {
    const response = await api.post(
      `/citas/recordatorios/${recordatorioId}/desmarcar-enviado/`
    );
    return response.data;
  } catch (error) {
    console.error("Error desmarcando recordatorio como enviado:", error);
    return null;
  }
};

// Obtener acción manual de WhatsApp para el modal de edición de cita
export const getWhatsappManualCita = async (citaId) => {
  try {
    const response = await api.post(`/citas/${citaId}/whatsapp-manual/`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo WhatsApp manual de cita:", error);
    return null;
  }
};

// Obtener personas agendadas que todavía no tienen expediente (sin alta)
export const getPersonasSinAlta = async () => {
  try {
    const response = await api.get("/citas/personas-sin-alta/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo personas sin alta:", error);
    return [];
  }
};

// ===== Personas de mi agenda (duplicados, archivar, eliminar, juntar) =====

// Las acciones regresan { ok, data }. Si falla, data.error trae el mensaje del servidor.
const accionPersonas = async (peticion, mensajeError) => {
  try {
    const response = await peticion;
    return { ok: true, data: response.data };
  } catch (error) {
    console.error(mensajeError, error);
    return { ok: false, data: error.response?.data || { error: mensajeError } };
  }
};

// Todas las personas sin alta, INCLUYENDO archivadas (para el modal "Personas de mi agenda")
export const getPersonasAgenda = async () => {
  try {
    const response = await api.get("/citas/personas-sin-alta/", {
      params: { incluir_archivadas: 1 },
    });
    return response.data;
  } catch (error) {
    console.error("Error obteniendo personas de la agenda:", error);
    return [];
  }
};

// Posibles duplicados pendientes de revisar
export const getDuplicados = async () => {
  try {
    const response = await api.get("/citas/duplicados/");
    return response.data;
  } catch (error) {
    console.error("Error obteniendo posibles duplicados:", error);
    return [];
  }
};

// "No son la misma persona"
export const descartarDuplicado = (parId) =>
  accionPersonas(
    api.post(`/citas/duplicados/${parId}/descartar/`),
    "No se pudo descartar. Intente de nuevo."
  );

// "Juntar en una": baseId = la persona que se conserva
export const juntarDuplicado = (parId, baseId) =>
  accionPersonas(
    api.post(`/citas/duplicados/${parId}/juntar/`, { base_id: baseId }),
    "No se pudieron juntar. Intente de nuevo."
  );

// Archivar (true) o desarchivar (false)
export const archivarPersona = (personaId, archivada) =>
  accionPersonas(
    api.post(`/citas/personas/${personaId}/archivar/`, { archivada }),
    "No se pudo actualizar a la persona. Intente de nuevo."
  );

// Eliminar a la persona con TODAS sus citas
export const eliminarPersona = (personaId) =>
  accionPersonas(
    api.post(`/citas/personas/${personaId}/eliminar/`),
    "No se pudo eliminar. Intente de nuevo."
  );


// Corregir los datos de una persona sin alta
export const editarPersona = (personaId, datos) =>
  accionPersonas(
    api.post(`/citas/personas/${personaId}/editar/`, datos),
    "No se pudieron guardar los cambios. Intente de nuevo."
  );

// "Juntar seleccionadas": baseId (persona de agenda) o pacienteId (con expediente) + otrasIds
export const juntarPersonas = ({ baseId = null, pacienteId = null, otrasIds = [] }) =>
  accionPersonas(
    api.post("/citas/personas/juntar/", {
      base_id: baseId,
      paciente_id: pacienteId,
      otras_ids: otrasIds,
    }),
    "No se pudieron juntar. Intente de nuevo."
  );

// ===== Ficha previa a la consulta =====

// Médico: justo al mandar un WhatsApp de una cita.
// Si a la persona le toca ficha, regresa el texto con el link nuevo para pegarlo al mensaje.
// Si no le toca (o falla), regresa "" y el mensaje sale normal.
export const getTextoFicha = async (citaId) => {
  try {
    const response = await api.post(`/citas/${citaId}/link-ficha/`);
    return response.data?.incluir ? response.data.texto : "";
  } catch (error) {
    console.error("Error obteniendo link de ficha:", error);
    return "";
  }
};

// Paciente (público): abre la ficha
export const getFichaPublica = async (token) => {
  try {
    const response = await api.get(`/ficha/${token}/`);
    return { ok: true, data: response.data };
  } catch (error) {
    console.error("Error abriendo ficha:", error);
    return {
      ok: false,
      data: error.response?.data || { error: "No se pudo abrir la ficha. Revisa tu conexión." },
    };
  }
};

// Paciente (público): manda sus respuestas
export const responderFichaPublica = async (token, datos) => {
  try {
    const response = await api.post(`/ficha/${token}/`, datos);
    return { ok: true, data: response.data };
  } catch (error) {
    console.error("Error enviando ficha:", error);
    return {
      ok: false,
      data: error.response?.data || { error: "No se pudo enviar la ficha. Intenta de nuevo." },
    };
  }
};


// ===== Agendamiento público (sin login) =====

// Datos del médico y reglas de su página pública
export const getAgendaPublica = async (bookingId) => {
  try {
    const response = await api.get(`/agendar/${bookingId}/`);
    return { ok: true, data: response.data };
  } catch (error) {
    console.error("Error abriendo agenda pública:", error);
    return {
      ok: false,
      data: error.response?.data || { error: "No se pudo abrir la página. Revisa tu conexión." },
    };
  }
};

// Horas libres de un día (fecha en formato AAAA-MM-DD)
export const getHorariosPublicos = async (bookingId, fecha) => {
  try {
    const response = await api.get(`/agendar/${bookingId}/horarios/`, { params: { fecha } });
    return { ok: true, data: response.data };
  } catch (error) {
    console.error("Error obteniendo horarios públicos:", error);
    return {
      ok: false,
      data: error.response?.data || { error: "No se pudieron cargar los horarios." },
    };
  }
};

// Agendar la cita con los datos del paciente
export const agendarPublico = async (bookingId, datos) => {
  try {
    const response = await api.post(`/agendar/${bookingId}/`, datos);
    return { ok: true, data: response.data };
  } catch (error) {
    console.error("Error agendando cita pública:", error);
    return {
      ok: false,
      data: error.response?.data || { error: "No se pudo agendar. Intenta de nuevo." },
    };
  }
};
